import { fg } from '@atlaskit/platform-feature-flags/fg';

import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from '../../../types/default-cloud-graph-project-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import {
	NounSubtypeKey,
	TypeFilterValueKey,
	type TypeFilterValue3PEntities,
} from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { ServiceNowIcon, ServiceNowSearchResultIcon } from './icon';

const getServiceNowTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	if (fg('rovo_fps_servicenow_type_filter_subtypes')) {
		config.set(TypeFilterValueKey.Incident, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Incident],
		});
		config.set(TypeFilterValueKey.CatalogItem, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.CatalogItem],
		});
		config.set(TypeFilterValueKey.RequestedItem, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.RequestedItem],
		});
		config.set(TypeFilterValueKey.Epic, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Epic],
		});
		config.set(TypeFilterValueKey.KnowledgeArticle, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.KnowledgeArticle],
		});
		config.set(TypeFilterValueKey.NewsArticle, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.NewsArticle],
		});
	} else {
		config.set(TypeFilterValueKey.WorkItem, {
			entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	if (fg('enable_rovo_search_comment_filter_for_servicenow')) {
		config.set(TypeFilterValueKey.Comment, {
			entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	if (fg('enable_rovo_search_project_filter_for_servicenow')) {
		config.set(TypeFilterValueKey.Project, {
			entities3P: DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Project],
		});
		config.set(TypeFilterValueKey.Demand, {
			entities3P: DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Demand],
		});
	}

	return config;
};

export const serviceNowConfig: ThirdPartyConfig = {
	displayName: 'ServiceNow',
	id: 'servicenow',
	icon: get3PLogo(ServiceNowIcon, 'ServiceNow', 'medium'),
	resourceType: ProductResourceTypes3P.ServiceNow,
	searchResultIcon: get3PLogo(ServiceNowSearchResultIcon, 'ServiceNow', 'large'),
	integrationAri: 'ari:cloud:platform::integration/servicenow', // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
	get typeFilterConfig() {
		return getServiceNowTypeFilterConfig();
	},
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
